module.exports = __webpack_public_path__ + "img/2025_YouthShirt.9bdcb4c4.jpg";